@file:OptIn(InternalResourceApi::class)

package swetgram.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/swetgram.shared.generated.resources/"

@delegate:ResourceContentHash(-1_171_806_570)
internal val Res.string.profile_error_username_change_too_soon: StringResource by lazy {
      StringResource("string:profile_error_username_change_too_soon", "profile_error_username_change_too_soon", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 8827, 190),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 5934, 118),
      ))
    }

@delegate:ResourceContentHash(-270_247_957)
internal val Res.string.profile_error_version_conflict: StringResource by lazy {
      StringResource("string:profile_error_version_conflict", "profile_error_version_conflict", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 9018, 286),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 6053, 154),
      ))
    }

@delegate:ResourceContentHash(2_014_088_668)
internal val Res.string.profile_joined_on: StringResource by lazy {
      StringResource("string:profile_joined_on", "profile_joined_on", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 9305, 53),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 6208, 45),
      ))
    }

@delegate:ResourceContentHash(2_065_446_710)
internal val Res.string.profile_label_birthday: StringResource by lazy {
      StringResource("string:profile_label_birthday", "profile_label_birthday", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 9359, 66),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 6254, 50),
      ))
    }

@delegate:ResourceContentHash(-626_816_397)
internal val Res.string.profile_label_location: StringResource by lazy {
      StringResource("string:profile_label_location", "profile_label_location", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 9426, 70),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 6305, 42),
      ))
    }

@delegate:ResourceContentHash(419_168_098)
internal val Res.string.profile_label_username: StringResource by lazy {
      StringResource("string:profile_label_username", "profile_label_username", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 9497, 74),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 6348, 42),
      ))
    }

@delegate:ResourceContentHash(-290_424_527)
internal val Res.string.profile_links_empty: StringResource by lazy {
      StringResource("string:profile_links_empty", "profile_links_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 9572, 83),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 6391, 55),
      ))
    }

@delegate:ResourceContentHash(-1_438_839_141)
internal val Res.string.profile_media_empty: StringResource by lazy {
      StringResource("string:profile_media_empty", "profile_media_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 9656, 95),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 6447, 55),
      ))
    }

@delegate:ResourceContentHash(1_268_486_043)
internal val Res.string.profile_message: StringResource by lazy {
      StringResource("string:profile_message", "profile_message", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 9752, 47),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 6503, 35),
      ))
    }

@delegate:ResourceContentHash(27_810_706)
internal val Res.string.profile_music_empty: StringResource by lazy {
      StringResource("string:profile_music_empty", "profile_music_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 9800, 83),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 6539, 55),
      ))
    }

@delegate:ResourceContentHash(-578_434_381)
internal val Res.string.profile_presence_last_seen_on: StringResource by lazy {
      StringResource("string:profile_presence_last_seen_on", "profile_presence_last_seen_on", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 9884, 93),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 6595, 61),
      ))
    }

@delegate:ResourceContentHash(-481_057_517)
internal val Res.string.profile_presence_last_seen_today: StringResource by lazy {
      StringResource("string:profile_presence_last_seen_today", "profile_presence_last_seen_today", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 9978, 120),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 6657, 64),
      ))
    }

@delegate:ResourceContentHash(-1_905_767_242)
internal val Res.string.profile_presence_last_seen_yesterday: StringResource by lazy {
      StringResource("string:profile_presence_last_seen_yesterday", "profile_presence_last_seen_yesterday", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 10099, 120),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 6722, 80),
      ))
    }

@delegate:ResourceContentHash(1_115_527_241)
internal val Res.string.profile_presence_offline: StringResource by lazy {
      StringResource("string:profile_presence_offline", "profile_presence_offline", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 10220, 56),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 6803, 44),
      ))
    }

@delegate:ResourceContentHash(342_917_441)
internal val Res.string.profile_presence_online: StringResource by lazy {
      StringResource("string:profile_presence_online", "profile_presence_online", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 10277, 47),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 6848, 39),
      ))
    }

@delegate:ResourceContentHash(-1_787_069_848)
internal val Res.string.profile_privacy_allow_profile_link: StringResource by lazy {
      StringResource("string:profile_privacy_allow_profile_link", "profile_privacy_allow_profile_link", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 10559, 110),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 7022, 66),
      ))
    }

@delegate:ResourceContentHash(-424_218_465)
internal val Res.string.profile_privacy_allow_profile_link_supporting: StringResource by lazy {
      StringResource("string:profile_privacy_allow_profile_link_supporting", "profile_privacy_allow_profile_link_supporting", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 10325, 233),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 6888, 133),
      ))
    }

@delegate:ResourceContentHash(-734_270_667)
internal val Res.string.profile_privacy_audience_everyone: StringResource by lazy {
      StringResource("string:profile_privacy_audience_everyone", "profile_privacy_audience_everyone", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 10670, 49),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 7089, 53),
      ))
    }

@delegate:ResourceContentHash(839_925_117)
internal val Res.string.profile_privacy_audience_existing_chats: StringResource by lazy {
      StringResource("string:profile_privacy_audience_existing_chats", "profile_privacy_audience_existing_chats", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 10720, 131),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 7143, 91),
      ))
    }

@delegate:ResourceContentHash(-1_111_294_311)
internal val Res.string.profile_privacy_audience_nobody: StringResource by lazy {
      StringResource("string:profile_privacy_audience_nobody", "profile_privacy_audience_nobody", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 10852, 55),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 7235, 47),
      ))
    }

@delegate:ResourceContentHash(491_966_470)
internal val Res.string.profile_privacy_audience_shared_groups: StringResource by lazy {
      StringResource("string:profile_privacy_audience_shared_groups", "profile_privacy_audience_shared_groups", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 10908, 102),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 7283, 74),
      ))
    }

@delegate:ResourceContentHash(638_555_411)
internal val Res.string.profile_privacy_message_footnote: StringResource by lazy {
      StringResource("string:profile_privacy_message_footnote", "profile_privacy_message_footnote", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 11011, 164),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 7358, 120),
      ))
    }

@delegate:ResourceContentHash(355_428_599)
internal val Res.string.profile_privacy_no_e2e: StringResource by lazy {
      StringResource("string:profile_privacy_no_e2e", "profile_privacy_no_e2e", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 11176, 122),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 7479, 98),
      ))
    }

@delegate:ResourceContentHash(1_052_662_360)
internal val Res.string.profile_privacy_section_profile_link: StringResource by lazy {
      StringResource("string:profile_privacy_section_profile_link", "profile_privacy_section_profile_link", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 11299, 88),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 7578, 60),
      ))
    }

@delegate:ResourceContentHash(-843_145_721)
internal val Res.string.profile_privacy_section_safety: StringResource by lazy {
      StringResource("string:profile_privacy_section_safety", "profile_privacy_section_safety", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 11388, 70),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 7639, 46),
      ))
    }

@delegate:ResourceContentHash(-1_489_269_260)
internal val Res.string.profile_privacy_show_date_of_birth: StringResource by lazy {
      StringResource("string:profile_privacy_show_date_of_birth", "profile_privacy_show_date_of_birth", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 11459, 102),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 7686, 82),
      ))
    }

@delegate:ResourceContentHash(-1_095_846_468)
internal val Res.string.profile_privacy_show_last_seen: StringResource by lazy {
      StringResource("string:profile_privacy_show_last_seen", "profile_privacy_show_last_seen", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 11562, 130),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 7769, 58),
      ))
    }

@delegate:ResourceContentHash(-1_216_098_074)
internal val Res.string.profile_privacy_show_location: StringResource by lazy {
      StringResource("string:profile_privacy_show_location", "profile_privacy_show_location", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 11693, 101),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 7828, 69),
      ))
    }

@delegate:ResourceContentHash(-655_432_497)
internal val Res.string.profile_privacy_show_online: StringResource by lazy {
      StringResource("string:profile_privacy_show_online", "profile_privacy_show_online", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 11795, 107),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 7898, 59),
      ))
    }

@delegate:ResourceContentHash(-807_076_376)
internal val Res.string.profile_privacy_title: StringResource by lazy {
      StringResource("string:profile_privacy_title", "profile_privacy_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 11903, 77),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 7958, 41),
      ))
    }

@delegate:ResourceContentHash(-1_790_553_480)
internal val Res.string.profile_privacy_unavailable_body: StringResource by lazy {
      StringResource("string:profile_privacy_unavailable_body", "profile_privacy_unavailable_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 11981, 116),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 8000, 84),
      ))
    }

@delegate:ResourceContentHash(-1_911_654_613)
internal val Res.string.profile_privacy_unavailable_title: StringResource by lazy {
      StringResource("string:profile_privacy_unavailable_title", "profile_privacy_unavailable_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 12098, 145),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 8085, 81),
      ))
    }

@delegate:ResourceContentHash(1_645_935_610)
internal val Res.string.profile_privacy_who_can_message: StringResource by lazy {
      StringResource("string:profile_privacy_who_can_message", "profile_privacy_who_can_message", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 12244, 115),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 8167, 63),
      ))
    }

@delegate:ResourceContentHash(-190_044_963)
internal val Res.string.profile_public_back: StringResource by lazy {
      StringResource("string:profile_public_back", "profile_public_back", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 12360, 43),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 8231, 35),
      ))
    }

@delegate:ResourceContentHash(1_938_317_249)
internal val Res.string.profile_public_blocked_by_me: StringResource by lazy {
      StringResource("string:profile_public_blocked_by_me", "profile_public_blocked_by_me", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 12404, 96),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 8267, 72),
      ))
    }

@delegate:ResourceContentHash(856_717_481)
internal val Res.string.profile_public_limited: StringResource by lazy {
      StringResource("string:profile_public_limited", "profile_public_limited", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 12501, 122),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 8340, 86),
      ))
    }

@delegate:ResourceContentHash(-1_504_778_956)
internal val Res.string.profile_public_more_actions: StringResource by lazy {
      StringResource("string:profile_public_more_actions", "profile_public_more_actions", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 12624, 83),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 8427, 63),
      ))
    }

@delegate:ResourceContentHash(1_072_479_137)
internal val Res.string.profile_public_show_qr: StringResource by lazy {
      StringResource("string:profile_public_show_qr", "profile_public_show_qr", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 12708, 86),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 8491, 58),
      ))
    }

@delegate:ResourceContentHash(-131_539_416)
internal val Res.string.profile_qr_copy_link: StringResource by lazy {
      StringResource("string:profile_qr_copy_link", "profile_qr_copy_link", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 12795, 76),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 8550, 40),
      ))
    }

@delegate:ResourceContentHash(-1_909_950_724)
internal val Res.string.profile_qr_entry: StringResource by lazy {
      StringResource("string:profile_qr_entry", "profile_qr_entry", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 12872, 56),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 8591, 40),
      ))
    }

@delegate:ResourceContentHash(-1_853_835_471)
internal val Res.string.profile_qr_link_copied: StringResource by lazy {
      StringResource("string:profile_qr_link_copied", "profile_qr_link_copied", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 12929, 78),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 8632, 46),
      ))
    }

@delegate:ResourceContentHash(-955_286_300)
internal val Res.string.profile_qr_link_only: StringResource by lazy {
      StringResource("string:profile_qr_link_only", "profile_qr_link_only", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 13008, 184),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 8679, 108),
      ))
    }

@delegate:ResourceContentHash(745_615_547)
internal val Res.string.profile_qr_scan_or_share: StringResource by lazy {
      StringResource("string:profile_qr_scan_or_share", "profile_qr_scan_or_share", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 13193, 144),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 8788, 88),
      ))
    }

@delegate:ResourceContentHash(-670_978_253)
internal val Res.string.profile_report: StringResource by lazy {
      StringResource("string:profile_report", "profile_report", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 13338, 54),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 8877, 30),
      ))
    }

@delegate:ResourceContentHash(1_018_497_457)
internal val Res.string.profile_settings: StringResource by lazy {
      StringResource("string:profile_settings", "profile_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 15663, 48),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 10486, 36),
      ))
    }

@delegate:ResourceContentHash(-1_456_743_580)
internal val Res.string.profile_settings_about: StringResource by lazy {
      StringResource("string:profile_settings_about", "profile_settings_about", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 13393, 62),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 8908, 38),
      ))
    }

@delegate:ResourceContentHash(198_183_705)
internal val Res.string.profile_settings_appearance: StringResource by lazy {
      StringResource("string:profile_settings_appearance", "profile_settings_appearance", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 13456, 63),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 8947, 51),
      ))
    }

@delegate:ResourceContentHash(-454_636_475)
internal val Res.string.profile_settings_chats: StringResource by lazy {
      StringResource("string:profile_settings_chats", "profile_settings_chats", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 13520, 42),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 8999, 38),
      ))
    }

@delegate:ResourceContentHash(-557_704_228)
internal val Res.string.profile_settings_delete_account: StringResource by lazy {
      StringResource("string:profile_settings_delete_account", "profile_settings_delete_account", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 14062, 79),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 9325, 59),
      ))
    }

@delegate:ResourceContentHash(-312_034_029)
internal val Res.string.profile_settings_delete_account_body: StringResource by lazy {
      StringResource("string:profile_settings_delete_account_body", "profile_settings_delete_account_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 13563, 412),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 9038, 212),
      ))
    }

@delegate:ResourceContentHash(-1_687_019_223)
internal val Res.string.profile_settings_delete_account_title: StringResource by lazy {
      StringResource("string:profile_settings_delete_account_title", "profile_settings_delete_account_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 13976, 85),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 9251, 73),
      ))
    }

@delegate:ResourceContentHash(-434_118_307)
internal val Res.string.profile_settings_deletion_on: StringResource by lazy {
      StringResource("string:profile_settings_deletion_on", "profile_settings_deletion_on", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 14142, 96),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 9385, 88),
      ))
    }

@delegate:ResourceContentHash(-388_591_409)
internal val Res.string.profile_settings_deletion_scheduled: StringResource by lazy {
      StringResource("string:profile_settings_deletion_scheduled", "profile_settings_deletion_scheduled", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 14239, 103),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 9474, 67),
      ))
    }

@delegate:ResourceContentHash(-2_033_497_159)
internal val Res.string.profile_settings_deletion_undated: StringResource by lazy {
      StringResource("string:profile_settings_deletion_undated", "profile_settings_deletion_undated", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 14343, 141),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 9542, 93),
      ))
    }

@delegate:ResourceContentHash(-2_139_625_471)
internal val Res.string.profile_settings_email: StringResource by lazy {
      StringResource("string:profile_settings_email", "profile_settings_email", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 14639, 46),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 9746, 38),
      ))
    }

@delegate:ResourceContentHash(-1_916_563_160)
internal val Res.string.profile_settings_email_unverified: StringResource by lazy {
      StringResource("string:profile_settings_email_unverified", "profile_settings_email_unverified", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 14485, 81),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 9636, 57),
      ))
    }

@delegate:ResourceContentHash(1_161_712_145)
internal val Res.string.profile_settings_email_verified: StringResource by lazy {
      StringResource("string:profile_settings_email_verified", "profile_settings_email_verified", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 14567, 71),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 9694, 51),
      ))
    }

@delegate:ResourceContentHash(-212_749_008)
internal val Res.string.profile_settings_keep_account: StringResource by lazy {
      StringResource("string:profile_settings_keep_account", "profile_settings_keep_account", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 14686, 81),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 9785, 57),
      ))
    }

@delegate:ResourceContentHash(604_897_916)
internal val Res.string.profile_settings_language: StringResource by lazy {
      StringResource("string:profile_settings_language", "profile_settings_language", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 14768, 45),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 9843, 45),
      ))
    }

@delegate:ResourceContentHash(964_326_687)
internal val Res.string.profile_settings_log_out: StringResource by lazy {
      StringResource("string:profile_settings_log_out", "profile_settings_log_out", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 15103, 48),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 10062, 44),
      ))
    }

@delegate:ResourceContentHash(1_242_161_679)
internal val Res.string.profile_settings_log_out_body: StringResource by lazy {
      StringResource("string:profile_settings_log_out_body", "profile_settings_log_out_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 14814, 205),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 9889, 121),
      ))
    }

@delegate:ResourceContentHash(-371_187_286)
internal val Res.string.profile_settings_log_out_title: StringResource by lazy {
      StringResource("string:profile_settings_log_out_title", "profile_settings_log_out_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 15020, 82),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 10011, 50),
      ))
    }

@delegate:ResourceContentHash(1_924_171_392)
internal val Res.string.profile_settings_moderation_reports: StringResource by lazy {
      StringResource("string:profile_settings_moderation_reports", "profile_settings_moderation_reports", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 15152, 59),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 10107, 55),
      ))
    }

@delegate:ResourceContentHash(975_773_952)
internal val Res.string.profile_settings_notifications: StringResource by lazy {
      StringResource("string:profile_settings_notifications", "profile_settings_notifications", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 15212, 70),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 10163, 58),
      ))
    }

@delegate:ResourceContentHash(-143_021_209)
internal val Res.string.profile_settings_section_account: StringResource by lazy {
      StringResource("string:profile_settings_section_account", "profile_settings_section_account", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 15283, 60),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 10222, 52),
      ))
    }

@delegate:ResourceContentHash(-283_727_221)
internal val Res.string.profile_settings_section_app: StringResource by lazy {
      StringResource("string:profile_settings_section_app", "profile_settings_section_app", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 15344, 64),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 10275, 40),
      ))
    }

@delegate:ResourceContentHash(657_795_132)
internal val Res.string.profile_settings_section_moderation: StringResource by lazy {
      StringResource("string:profile_settings_section_moderation", "profile_settings_section_moderation", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 15409, 67),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 10316, 59),
      ))
    }

@delegate:ResourceContentHash(1_601_304_169)
internal val Res.string.profile_settings_section_privacy: StringResource by lazy {
      StringResource("string:profile_settings_section_privacy", "profile_settings_section_privacy", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 15477, 128),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 10376, 64),
      ))
    }

@delegate:ResourceContentHash(1_805_684_807)
internal val Res.string.profile_settings_storage: StringResource by lazy {
      StringResource("string:profile_settings_storage", "profile_settings_storage", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 15606, 56),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 10441, 44),
      ))
    }

@delegate:ResourceContentHash(-372_532_061)
internal val Res.string.profile_share_profile: StringResource by lazy {
      StringResource("string:profile_share_profile", "profile_share_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 15712, 81),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 10523, 49),
      ))
    }

@delegate:ResourceContentHash(-1_258_284_752)
internal val Res.string.profile_tab_links: StringResource by lazy {
      StringResource("string:profile_tab_links", "profile_tab_links", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 15794, 41),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 10573, 33),
      ))
    }

@delegate:ResourceContentHash(1_019_597_735)
internal val Res.string.profile_tab_media: StringResource by lazy {
      StringResource("string:profile_tab_media", "profile_tab_media", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 15836, 41),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 10607, 33),
      ))
    }

@delegate:ResourceContentHash(-1_960_248_381)
internal val Res.string.profile_tab_music: StringResource by lazy {
      StringResource("string:profile_tab_music", "profile_tab_music", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 15878, 41),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 10641, 33),
      ))
    }

@delegate:ResourceContentHash(-1_479_163_194)
internal val Res.string.profile_tab_voice: StringResource by lazy {
      StringResource("string:profile_tab_voice", "profile_tab_voice", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 15920, 49),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 10675, 33),
      ))
    }

@delegate:ResourceContentHash(157_767_874)
internal val Res.string.profile_title: StringResource by lazy {
      StringResource("string:profile_title", "profile_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 15970, 41),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 10709, 33),
      ))
    }

@delegate:ResourceContentHash(1_796_747_229)
internal val Res.string.profile_try_again: StringResource by lazy {
      StringResource("string:profile_try_again", "profile_try_again", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 16012, 49),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 10743, 37),
      ))
    }

@delegate:ResourceContentHash(-1_006_682_848)
internal val Res.string.profile_unavailable_body_mine: StringResource by lazy {
      StringResource("string:profile_unavailable_body_mine", "profile_unavailable_body_mine", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 16062, 149),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 10781, 93),
      ))
    }

@delegate:ResourceContentHash(-1_506_032_273)
internal val Res.string.profile_unavailable_body_theirs: StringResource by lazy {
      StringResource("string:profile_unavailable_body_theirs", "profile_unavailable_body_theirs", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 16212, 123),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 10875, 83),
      ))
    }

@delegate:ResourceContentHash(331_158_379)
internal val Res.string.profile_unavailable_title: StringResource by lazy {
      StringResource("string:profile_unavailable_title", "profile_unavailable_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 16336, 81),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 10959, 61),
      ))
    }

@delegate:ResourceContentHash(1_948_869_054)
internal val Res.string.profile_unblock: StringResource by lazy {
      StringResource("string:profile_unblock", "profile_unblock", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 16761, 63),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 11208, 35),
      ))
    }

@delegate:ResourceContentHash(368_878_596)
internal val Res.string.profile_unblock_body: StringResource by lazy {
      StringResource("string:profile_unblock_body", "profile_unblock_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 16418, 232),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 11021, 136),
      ))
    }

@delegate:ResourceContentHash(-1_047_350_183)
internal val Res.string.profile_unblock_title: StringResource by lazy {
      StringResource("string:profile_unblock_title", "profile_unblock_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 16651, 109),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 11158, 49),
      ))
    }

@delegate:ResourceContentHash(-2_082_293_392)
internal val Res.string.profile_voice_empty: StringResource by lazy {
      StringResource("string:profile_voice_empty", "profile_voice_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 16825, 115),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 11244, 67),
      ))
    }

@delegate:ResourceContentHash(-860_869_078)
internal val Res.string.shop_balance_title: StringResource by lazy {
      StringResource("string:shop_balance_title", "shop_balance_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_shop.commonMain.cvr", 10, 54),
        ResourceItem(setOf(), "${MD}values/strings_shop.commonMain.cvr", 10, 42),
      ))
    }

@delegate:ResourceContentHash(429_837_132)
internal val Res.string.shop_buy_action: StringResource by lazy {
      StringResource("string:shop_buy_action", "shop_buy_action", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_shop.commonMain.cvr", 65, 59),
        ResourceItem(setOf(), "${MD}values/strings_shop.commonMain.cvr", 53, 43),
      ))
    }

@delegate:ResourceContentHash(399_665_320)
internal val Res.string.shop_category_icons: StringResource by lazy {
      StringResource("string:shop_category_icons", "shop_category_icons", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_shop.commonMain.cvr", 125, 71),
        ResourceItem(setOf(), "${MD}values/strings_shop.commonMain.cvr", 97, 47),
      ))
    }

@delegate:ResourceContentHash(775_036_590)
internal val Res.string.shop_category_other: StringResource by lazy {
      StringResource("string:shop_category_other", "shop_category_other", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_shop.commonMain.cvr", 197, 63),
        ResourceItem(setOf(), "${MD}values/strings_shop.commonMain.cvr", 145, 47),
      ))
    }

@delegate:ResourceContentHash(-2_040_411_494)
internal val Res.string.shop_category_perks: StringResource by lazy {
      StringResource("string:shop_category_perks", "shop_category_perks", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_shop.commonMain.cvr", 261, 67),
        ResourceItem(setOf(), "${MD}values/strings_shop.commonMain.cvr", 193, 51),
      ))
    }

@delegate:ResourceContentHash(1_038_409_325)
internal val Res.string.shop_category_profile: StringResource by lazy {
      StringResource("string:shop_category_profile", "shop_category_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_shop.commonMain.cvr", 329, 81),
        ResourceItem(setOf(), "${MD}values/strings_shop.commonMain.cvr", 245, 57),
      ))
    }

@delegate:ResourceContentHash(-1_080_971_723)
internal val Res.string.shop_category_streaks: StringResource by lazy {
      StringResource("string:shop_category_streaks", "shop_category_streaks", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_shop.commonMain.cvr", 411, 69),
        ResourceItem(setOf(), "${MD}values/strings_shop.commonMain.cvr", 303, 57),
      ))
    }

@delegate:ResourceContentHash(966_556_220)
internal val Res.string.shop_confirm_body: StringResource by lazy {
      StringResource("string:shop_confirm_body", "shop_confirm_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_shop.commonMain.cvr", 481, 101),
        ResourceItem(setOf(), "${MD}values/strings_shop.commonMain.cvr", 361, 69),
      ))
    }

@delegate:ResourceContentHash(-347_039_336)
internal val Res.string.shop_confirm_no: StringResource by lazy {
      StringResource("string:shop_confirm_no", "shop_confirm_no", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_shop.commonMain.cvr", 583, 39),
        ResourceItem(setOf(), "${MD}values/strings_shop.commonMain.cvr", 431, 31),
      ))
    }

@delegate:ResourceContentHash(1_627_429_240)
internal val Res.string.shop_confirm_title: StringResource by lazy {
      StringResource("string:shop_confirm_title", "shop_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_shop.commonMain.cvr", 623, 82),
        ResourceItem(setOf(), "${MD}values/strings_shop.commonMain.cvr", 463, 50),
      ))
    }

@delegate:ResourceContentHash(1_280_799_085)
internal val Res.string.shop_confirm_yes: StringResource by lazy {
      StringResource("string:shop_confirm_yes", "shop_confirm_yes", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_shop.commonMain.cvr", 706, 40),
        ResourceItem(setOf(), "${MD}values/strings_shop.commonMain.cvr", 514, 28),
      ))
    }

@delegate:ResourceContentHash(-1_953_082_460)
internal val Res.string.shop_empty: StringResource by lazy {
      StringResource("string:shop_empty", "shop_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_shop.commonMain.cvr", 747, 102),
        ResourceItem(setOf(), "${MD}values/strings_shop.commonMain.cvr", 543, 62),
      ))
    }

@delegate:ResourceContentHash(-536_253_081)
internal val Res.string.shop_error_load: StringResource by lazy {
      StringResource("string:shop_error_load", "shop_error_load", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_shop.commonMain.cvr", 850, 119),
        ResourceItem(setOf(), "${MD}values/strings_shop.commonMain.cvr", 606, 59),
      ))
    }

@delegate:ResourceContentHash(-1_558_946_895)
internal val Res.string.shop_freezes_badge: StringResource by lazy {
      StringResource("string:shop_freezes_badge", "shop_freezes_badge", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_shop.commonMain.cvr", 970, 42),
        ResourceItem(setOf(), "${MD}values/strings_shop.commonMain.cvr", 666, 42),
      ))
    }

@delegate:ResourceContentHash(2_088_331_878)
internal val Res.string.shop_freezes_tooltip: StringResource by lazy {
      StringResource("string:shop_freezes_tooltip", "shop_freezes_tooltip", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_shop.commonMain.cvr", 1013, 132),
        ResourceItem(setOf(), "${MD}values/strings_shop.commonMain.cvr", 709, 92),
      ))
    }

@delegate:ResourceContentHash(-1_313_006_100)
internal val Res.string.shop_insufficient_xp: StringResource by lazy {
      StringResource("string:shop_insufficient_xp", "shop_insufficient_xp", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_shop.commonMain.cvr", 1146, 128),
        ResourceItem(setOf(), "${MD}values/strings_shop.commonMain.cvr", 802, 76),
      ))
    }

@delegate:ResourceContentHash(-68_202_177)
internal val Res.string.shop_max_freezes: StringResource by lazy {
      StringResource("string:shop_max_freezes", "shop_max_freezes", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_shop.commonMain.cvr", 1275, 120),
        ResourceItem(setOf(), "${MD}values/strings_shop.commonMain.cvr", 879, 84),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString7Resources(map: MutableMap<String, StringResource>) {
  map.put("profile_error_username_change_too_soon", Res.string.profile_error_username_change_too_soon)
  map.put("profile_error_version_conflict", Res.string.profile_error_version_conflict)
  map.put("profile_joined_on", Res.string.profile_joined_on)
  map.put("profile_label_birthday", Res.string.profile_label_birthday)
  map.put("profile_label_location", Res.string.profile_label_location)
  map.put("profile_label_username", Res.string.profile_label_username)
  map.put("profile_links_empty", Res.string.profile_links_empty)
  map.put("profile_media_empty", Res.string.profile_media_empty)
  map.put("profile_message", Res.string.profile_message)
  map.put("profile_music_empty", Res.string.profile_music_empty)
  map.put("profile_presence_last_seen_on", Res.string.profile_presence_last_seen_on)
  map.put("profile_presence_last_seen_today", Res.string.profile_presence_last_seen_today)
  map.put("profile_presence_last_seen_yesterday", Res.string.profile_presence_last_seen_yesterday)
  map.put("profile_presence_offline", Res.string.profile_presence_offline)
  map.put("profile_presence_online", Res.string.profile_presence_online)
  map.put("profile_privacy_allow_profile_link", Res.string.profile_privacy_allow_profile_link)
  map.put("profile_privacy_allow_profile_link_supporting", Res.string.profile_privacy_allow_profile_link_supporting)
  map.put("profile_privacy_audience_everyone", Res.string.profile_privacy_audience_everyone)
  map.put("profile_privacy_audience_existing_chats", Res.string.profile_privacy_audience_existing_chats)
  map.put("profile_privacy_audience_nobody", Res.string.profile_privacy_audience_nobody)
  map.put("profile_privacy_audience_shared_groups", Res.string.profile_privacy_audience_shared_groups)
  map.put("profile_privacy_message_footnote", Res.string.profile_privacy_message_footnote)
  map.put("profile_privacy_no_e2e", Res.string.profile_privacy_no_e2e)
  map.put("profile_privacy_section_profile_link", Res.string.profile_privacy_section_profile_link)
  map.put("profile_privacy_section_safety", Res.string.profile_privacy_section_safety)
  map.put("profile_privacy_show_date_of_birth", Res.string.profile_privacy_show_date_of_birth)
  map.put("profile_privacy_show_last_seen", Res.string.profile_privacy_show_last_seen)
  map.put("profile_privacy_show_location", Res.string.profile_privacy_show_location)
  map.put("profile_privacy_show_online", Res.string.profile_privacy_show_online)
  map.put("profile_privacy_title", Res.string.profile_privacy_title)
  map.put("profile_privacy_unavailable_body", Res.string.profile_privacy_unavailable_body)
  map.put("profile_privacy_unavailable_title", Res.string.profile_privacy_unavailable_title)
  map.put("profile_privacy_who_can_message", Res.string.profile_privacy_who_can_message)
  map.put("profile_public_back", Res.string.profile_public_back)
  map.put("profile_public_blocked_by_me", Res.string.profile_public_blocked_by_me)
  map.put("profile_public_limited", Res.string.profile_public_limited)
  map.put("profile_public_more_actions", Res.string.profile_public_more_actions)
  map.put("profile_public_show_qr", Res.string.profile_public_show_qr)
  map.put("profile_qr_copy_link", Res.string.profile_qr_copy_link)
  map.put("profile_qr_entry", Res.string.profile_qr_entry)
  map.put("profile_qr_link_copied", Res.string.profile_qr_link_copied)
  map.put("profile_qr_link_only", Res.string.profile_qr_link_only)
  map.put("profile_qr_scan_or_share", Res.string.profile_qr_scan_or_share)
  map.put("profile_report", Res.string.profile_report)
  map.put("profile_settings", Res.string.profile_settings)
  map.put("profile_settings_about", Res.string.profile_settings_about)
  map.put("profile_settings_appearance", Res.string.profile_settings_appearance)
  map.put("profile_settings_chats", Res.string.profile_settings_chats)
  map.put("profile_settings_delete_account", Res.string.profile_settings_delete_account)
  map.put("profile_settings_delete_account_body", Res.string.profile_settings_delete_account_body)
  map.put("profile_settings_delete_account_title", Res.string.profile_settings_delete_account_title)
  map.put("profile_settings_deletion_on", Res.string.profile_settings_deletion_on)
  map.put("profile_settings_deletion_scheduled", Res.string.profile_settings_deletion_scheduled)
  map.put("profile_settings_deletion_undated", Res.string.profile_settings_deletion_undated)
  map.put("profile_settings_email", Res.string.profile_settings_email)
  map.put("profile_settings_email_unverified", Res.string.profile_settings_email_unverified)
  map.put("profile_settings_email_verified", Res.string.profile_settings_email_verified)
  map.put("profile_settings_keep_account", Res.string.profile_settings_keep_account)
  map.put("profile_settings_language", Res.string.profile_settings_language)
  map.put("profile_settings_log_out", Res.string.profile_settings_log_out)
  map.put("profile_settings_log_out_body", Res.string.profile_settings_log_out_body)
  map.put("profile_settings_log_out_title", Res.string.profile_settings_log_out_title)
  map.put("profile_settings_moderation_reports", Res.string.profile_settings_moderation_reports)
  map.put("profile_settings_notifications", Res.string.profile_settings_notifications)
  map.put("profile_settings_section_account", Res.string.profile_settings_section_account)
  map.put("profile_settings_section_app", Res.string.profile_settings_section_app)
  map.put("profile_settings_section_moderation", Res.string.profile_settings_section_moderation)
  map.put("profile_settings_section_privacy", Res.string.profile_settings_section_privacy)
  map.put("profile_settings_storage", Res.string.profile_settings_storage)
  map.put("profile_share_profile", Res.string.profile_share_profile)
  map.put("profile_tab_links", Res.string.profile_tab_links)
  map.put("profile_tab_media", Res.string.profile_tab_media)
  map.put("profile_tab_music", Res.string.profile_tab_music)
  map.put("profile_tab_voice", Res.string.profile_tab_voice)
  map.put("profile_title", Res.string.profile_title)
  map.put("profile_try_again", Res.string.profile_try_again)
  map.put("profile_unavailable_body_mine", Res.string.profile_unavailable_body_mine)
  map.put("profile_unavailable_body_theirs", Res.string.profile_unavailable_body_theirs)
  map.put("profile_unavailable_title", Res.string.profile_unavailable_title)
  map.put("profile_unblock", Res.string.profile_unblock)
  map.put("profile_unblock_body", Res.string.profile_unblock_body)
  map.put("profile_unblock_title", Res.string.profile_unblock_title)
  map.put("profile_voice_empty", Res.string.profile_voice_empty)
  map.put("shop_balance_title", Res.string.shop_balance_title)
  map.put("shop_buy_action", Res.string.shop_buy_action)
  map.put("shop_category_icons", Res.string.shop_category_icons)
  map.put("shop_category_other", Res.string.shop_category_other)
  map.put("shop_category_perks", Res.string.shop_category_perks)
  map.put("shop_category_profile", Res.string.shop_category_profile)
  map.put("shop_category_streaks", Res.string.shop_category_streaks)
  map.put("shop_confirm_body", Res.string.shop_confirm_body)
  map.put("shop_confirm_no", Res.string.shop_confirm_no)
  map.put("shop_confirm_title", Res.string.shop_confirm_title)
  map.put("shop_confirm_yes", Res.string.shop_confirm_yes)
  map.put("shop_empty", Res.string.shop_empty)
  map.put("shop_error_load", Res.string.shop_error_load)
  map.put("shop_freezes_badge", Res.string.shop_freezes_badge)
  map.put("shop_freezes_tooltip", Res.string.shop_freezes_tooltip)
  map.put("shop_insufficient_xp", Res.string.shop_insufficient_xp)
  map.put("shop_max_freezes", Res.string.shop_max_freezes)
}
